import React from "react";

import "./FaceIcon.scss";

export type FaceIconProps = {
  cx?:
    | "positive-1"
    | "positive-2"
    | "positive-3"
    | "neutral"
    | "negative-1"
    | "negative-2"
    | "negative-3"
    | "default";
};

export const FaceIcon: React.FC<FaceIconProps> = ({ cx = "default" }) => {
  return (
    <svg
      width="50"
      height="50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`FaceIcon ${cx}`}
    >
      {/*<circle cx="25" cy="25" r="25" className={cx} />*/}
      {/*<circle cx="25" cy="25" r="24.5" stroke="#111" strokeOpacity=".8" />*/}
      <g className="negative-1">
        <path
          d="M5.597 50h37.806c4.155 0 6.858-4.374 5-8.092L29.499 4.091c-2.06-4.121-7.938-4.121-9.998 0L.597 41.908c-1.858 3.718.845 8.092 5 8.092z"
          fill="#E82C20"
        />
        <path
          d="M43.403 49.5H5.597c-3.784 0-6.245-3.983-4.552-7.368L19.948 4.314c1.875-3.752 7.229-3.752 9.104 0l18.904 37.818c1.692 3.385-.77 7.368-4.553 7.368z"
          stroke="#111"
          strokeOpacity=".8"
        />
        <mask
          id="a"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="11"
          y="25"
          width="9"
          height="7"
        >
          <path
            d="m19.13 25.85-7.973.536c.251 5.021 3.5 5.596 5.092 5.256 3.409-1.06 3.342-4.303 2.882-5.792z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#a)">
          <path
            d="m19.13 25.85-7.973.536c.251 5.021 3.5 5.596 5.092 5.256 3.409-1.06 3.342-4.303 2.882-5.792z"
            fill="#fff"
          />
          <circle
            cx="15.376"
            cy="26.984"
            r="2.122"
            transform="rotate(-34.807 15.376 26.984)"
            fill="#111"
          />
        </g>
        <mask
          id="b"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="20"
          y="22"
          width="9"
          height="8"
        >
          <path
            d="m27.538 22.584-7.296 3.263c1.974 4.624 5.22 4.04 6.597 3.168 2.83-2.174 1.645-5.193.699-6.43z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path
            d="m27.538 22.584-7.296 3.263c1.974 4.624 5.22 4.04 6.597 3.168 2.83-2.174 1.645-5.193.699-6.43z"
            fill="#fff"
          />
          <circle
            cx="24.347"
            cy="25.062"
            r="2.122"
            transform="rotate(-34.807 24.347 25.062)"
            fill="#111"
          />
        </g>
        <path
          d="M14.148 15.389c-.107 1.131.018 1.957.367 2.734.373.831.978 1.619 1.773 2.747.059.08.212.043.228-.055.075-.551.167-.778.304-1.011.059.245.175.438.318.592.212.23.459.4.634.617.175.217.289.476.25.934-.039.458-.242 1.11-.733 2.062-.045.084.042.2.135.183.245-.047.498-.2.75-.424-.374.535-.715.994-1.14 1.367.024-1.41-.824-2.565-1.723-3.65-.967-1.167-1.994-2.27-2.17-3.525-.017-.128-.142-.14-.223-.062-.918 1.096-.962 2.147-.858 3.04.052.445.137.854.166 1.213.026.32-.005.59-.117.828-.295-.254-.364-.75-.403-1.017-.092-.23-.3-.083-.387.106-.205.506-.197 1.13-.164 1.601.062.823.292 1.79.817 2.557-.829-.312-1.599-.844-2.027-1.43.238.059.477.047.66-.093a.13.13 0 0 0 .027-.177c-.58-.756-.743-1.607-.7-2.455.032-.644.196-1.264.38-1.843.131.471.422.866.8.881.177-.006.25-.113.256-.245-.09-.811-.16-1.864.195-2.88.34-.972 1.084-1.91 2.585-2.596z"
          fill="#FFA928"
        />
        <path
          d="M13.133 20.22c.34.764 1.051 1.532 1.643 2.347.325.447.607.907.767 1.369.152.439.194.875.063 1.333-.35.456-1.923.678-2.23.493-.258-.307-.495-.876-.61-1.375-.063-.296-.113-.557-.047-.826.155.218.3.365.53.39a.309.309 0 0 0 .251-.141c.084-.278.037-.585-.05-.902-.18-.67-.508-1.315-.519-1.975a1.396 1.396 0 0 1 .202-.713z"
          fill="#FAF262"
        />
        <path
          d="M23.506 13.346c-.108 1.131.018 1.957.366 2.734.373.832.979 1.619 1.773 2.747.06.08.212.043.228-.055.075-.551.167-.778.304-1.011.06.245.176.438.319.592.211.23.458.4.633.617.175.217.29.476.25.934-.038.458-.242 1.11-.733 2.062-.045.083.042.2.136.183.244-.047.498-.2.75-.424-.374.535-.716.994-1.14 1.367.023-1.41-.824-2.565-1.723-3.65-.967-1.167-1.995-2.27-2.172-3.525-.016-.128-.14-.14-.221-.062-.919 1.096-.963 2.147-.859 3.04.052.445.138.854.167 1.214.026.319-.006.59-.117.827-.295-.254-.364-.75-.403-1.017-.092-.23-.3-.083-.388.106-.205.506-.197 1.13-.163 1.601.061.823.291 1.79.817 2.557-.83-.312-1.6-.844-2.027-1.43.237.059.476.046.66-.093a.13.13 0 0 0 .027-.177c-.58-.756-.744-1.607-.701-2.455.032-.644.196-1.264.38-1.843.132.471.422.866.8.882.177-.007.25-.114.257-.245-.09-.812-.16-1.865.194-2.882.34-.971 1.084-1.91 2.585-2.594z"
          fill="#FFA928"
        />
        <path
          d="M22.49 18.177c.34.764 1.052 1.532 1.644 2.347.324.447.607.907.766 1.368.152.44.194.876.063 1.334-.35.456-1.923.678-2.23.492-.257-.306-.495-.875-.61-1.374-.063-.296-.112-.557-.047-.826.155.218.3.365.53.39a.31.31 0 0 0 .252-.141c.084-.278.036-.585-.05-.902-.181-.67-.509-1.314-.52-1.974a1.396 1.396 0 0 1 .203-.714z"
          fill="#FAF262"
        />
        <mask
          id="c"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="15"
          y="33"
          width="15"
          height="12"
        >
          <path
            d="M21.209 43.424c-3.456 2.083-5.194-.518-5.631-2.078-.227-.807-.368-2.927.877-4.947 1.556-2.525 6.813-3.65 10.029-2.113 3.216 1.536 3.727 9.576.692 8.685-2.428-.712-4.99.005-5.967.453z"
            fill="#6E1711"
          />
        </mask>
        <g mask="url(#c)">
          <path
            d="M21.209 43.424c-3.456 2.083-5.194-.518-5.631-2.078-.227-.807-.368-2.927.877-4.947 1.556-2.525 6.813-3.65 10.029-2.113 3.216 1.536 3.727 9.576.692 8.685-2.428-.712-4.99.005-5.967.453z"
            fill="#111"
          />
          <path
            d="m21.171 35.165-.171.033a.919.919 0 0 1-.347-1.805l.171-.033a.919.919 0 1 1 .347 1.805zM21.864 43.849l-.171.033a.919.919 0 1 1-.347-1.805l.171-.033a.919.919 0 0 1 .348 1.805zM24.214 43.536l-.171.033a.919.919 0 1 1-.348-1.805l.172-.033a.919.919 0 0 1 .347 1.805zM23.566 35.017l-.172.033a.919.919 0 1 1-.347-1.805l.172-.033a.919.919 0 0 1 .347 1.805z"
            fill="#fff"
          />
        </g>
      </g>
      <g className="negative-2">
        <path
          d="M5.597 50h37.806c4.155 0 6.858-4.374 5-8.092L29.499 4.091c-2.06-4.121-7.938-4.121-9.998 0L.597 41.908c-1.858 3.718.845 8.092 5 8.092z"
          fill="#E82C20"
        />
        <path
          d="M43.403 49.5H5.597c-3.784 0-6.245-3.983-4.552-7.368L19.948 4.314c1.875-3.752 7.229-3.752 9.104 0l18.904 37.818c1.692 3.385-.77 7.368-4.553 7.368z"
          stroke="#111"
          strokeOpacity=".8"
        />
        <path
          d="M27.85 46.367c.072.491-.972.445-2.226.629-1.253.184-2.241.527-2.313.036-.072-.49.799-1.63 2.053-1.814 1.253-.184 2.415.658 2.487 1.15z"
          fill="#111"
          fillOpacity=".3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.902 25.817a6.03 6.03 0 0 0 .174 2.275c.732 2.725 3.136 4.447 5.369 3.847 2.232-.601 3.447-3.297 2.715-6.021-.443-1.645-1.494-2.925-2.75-3.549a4.923 4.923 0 0 1-2.19 1.994l-2.605 1.194a4.7 4.7 0 0 1-.713.26z"
          fill="#fff"
        />
        <circle
          cx="19.161"
          cy="27.165"
          r="2.065"
          transform="rotate(-15.056 19.161 27.165)"
          fill="#111"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.836 21.305c-1.136 1.049-1.867 2.69-1.867 4.534 0 3.168 2.157 5.735 4.817 5.735 2.661 0 4.818-2.567 4.818-5.735 0-1.58-.537-3.012-1.406-4.05a4.692 4.692 0 0 1-3.455.923 5.058 5.058 0 0 1-2.907-1.407z"
          fill="#fff"
        />
        <circle cx="27.933" cy="26.064" r="2.294" fill="#111" />
        <path
          d="M28.328 42.674c4.538.822 5.672-1.456 5.672-2.699 0-.642-.508-2.236-2.543-3.47-2.542-1.542-7.175-1.8-10.304 0-3.13 1.799-2.8 8.354.33 7.069 2.503-1.029 5.606-1.029 6.845-.9z"
          fill="#111"
        />
        <path
          d="M28.017 37.605c-2.291-.255-6.286 1.24-6.653.689s.306-1.147.688-1.376c.896-.538 2.157-.413 4.359-.23 2.202.184 3.518.688 3.9.917 0 .46-.23.23-2.294 0z"
          fill="#fff"
        />
      </g>
      <g className="negative-3">
        <path
          d="M5.597 50h37.806c4.155 0 6.858-4.374 5-8.092L29.499 4.091c-2.06-4.121-7.938-4.121-9.998 0L.597 41.908c-1.858 3.718.845 8.092 5 8.092z"
          fill="#FFA858"
        />
        <path
          d="M43.403 49.5H5.597c-3.784 0-6.245-3.983-4.552-7.368L19.948 4.314c1.875-3.752 7.229-3.752 9.104 0l18.904 37.818c1.692 3.385-.77 7.368-4.553 7.368z"
          stroke="#111"
          strokeOpacity=".8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8 27.102a5.339 5.339 0 0 0-.468 2.206c0 2.572 1.756 4.657 3.922 4.657 2.165 0 3.921-2.086 3.921-4.657 0-.799-.169-1.55-.467-2.206H13.8zM21.711 27.098a6.103 6.103 0 0 0-.533 2.52c0 2.94 2.006 5.322 4.482 5.322 2.475 0 4.481-2.383 4.481-5.322 0-.912-.193-1.77-.533-2.52H21.71z"
          fill="#fff"
        />
        <ellipse cx="17.991" cy="30.039" rx="1.716" ry="1.961" fill="#111" />
        <ellipse cx="26.568" cy="30.284" rx="1.961" ry="2.206" fill="#111" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.346 40.206c-2.938-1.9-5.439-.765-6.247-.068A.782.782 0 0 1 16.945 40a.931.931 0 0 1 .129-1.243c1.243-1.072 4.488-2.414 8.116-.068.39.251.515.795.282 1.213-.233.42-.737.555-1.126.304z"
          fill="#111"
        />
      </g>
      <g className={"default"}>
        <circle cx="25" cy="25" r="25" fill="#787878" />
        <circle cx="25" cy="25" r="24.5" stroke="#111" strokeOpacity=".8" />
        <path
          d="M25.001 21.81a4.657 4.657 0 1 1-9.314 0 4.657 4.657 0 0 1 9.314 0z"
          fill="#fff"
        />
        <circle cx="20.345" cy="22.303" r="2.206" fill="#111" />
        <path
          d="M34.314 21.813a4.657 4.657 0 1 1-9.314 0 4.657 4.657 0 0 1 9.314 0z"
          fill="#fff"
        />
        <circle cx="29.657" cy="22.303" r="2.206" fill="#111" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.269 32.651a.98.98 0 0 1-.439 1.316c-1.435.718-3.768 1.023-5.922 1.023-1.101 0-2.205-.08-3.19-.244-.968-.16-1.892-.413-2.587-.799a.98.98 0 0 1 .953-1.714c.408.227 1.077.433 1.955.58.86.142 1.856.216 2.869.216 2.074 0 4.03-.308 5.045-.816a.98.98 0 0 1 1.316.438z"
          fill="#111"
        />
      </g>

      <g className="neutral">
        <rect x="1" y="1" width="48" height="48" rx="5" fill="#80BA27" />
        <rect
          x="1.5"
          y="1.5"
          width="47"
          height="47"
          rx="4.5"
          stroke="#111"
          strokeOpacity=".8"
        />
        <path
          d="M25.001 21.81a4.657 4.657 0 1 1-9.314 0 4.657 4.657 0 0 1 9.314 0z"
          fill="#fff"
        />
        <circle cx="20.345" cy="22.303" r="2.206" fill="#111" />
        <path
          d="M34.314 21.813a4.657 4.657 0 1 1-9.314 0 4.657 4.657 0 0 1 9.314 0z"
          fill="#fff"
        />
        <circle cx="29.657" cy="22.303" r="2.206" fill="#111" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.269 32.651a.98.98 0 0 1-.439 1.316c-1.435.718-3.768 1.023-5.922 1.023-1.101 0-2.205-.08-3.19-.244-.968-.16-1.892-.413-2.587-.799a.98.98 0 0 1 .953-1.714c.408.227 1.077.433 1.955.58.86.142 1.856.216 2.869.216 2.074 0 4.03-.308 5.045-.816a.98.98 0 0 1 1.316.438z"
          fill="#111"
        />
        <ellipse
          cx="38.234"
          cy="28.188"
          rx="2.941"
          ry="1.716"
          transform="rotate(-17.449 38.234 28.188)"
          fill="#111"
          fillOpacity=".3"
        />
        <ellipse
          cx="11.162"
          cy="28.188"
          rx="2.941"
          ry="1.716"
          transform="rotate(15 11.162 28.188)"
          fill="#111"
          fillOpacity=".3"
        />
      </g>
      <g className="positive-1">
        <circle cx="25" cy="25" r="25" fill="#0085FF" />
        <circle cx="25" cy="25" r="24.5" stroke="#111" strokeOpacity=".8" />
        <circle cx="20.311" cy="18.75" r="5.25" fill="#fff" />
        <circle cx="29.809" cy="18.75" r="5.25" fill="#fff" />
        <path
          d="M17.938 15.5c-.517 0-.994.203-1.338.578-.344.383-.54.907-.54 1.477 0 .602.227 1.15.728 1.75.485.587 1.212 1.204 2.049 1.923.258.22.54.461.837.72.078.07.195.07.273 0 .298-.259.587-.5.837-.72.837-.71 1.564-1.328 2.05-1.922.5-.61.727-1.149.727-1.75 0-.571-.196-1.095-.54-1.478a1.791 1.791 0 0 0-1.33-.578c-.375 0-.727.117-1.032.36a2.32 2.32 0 0 0-.57.656.333.333 0 0 1-.196.148.316.316 0 0 1-.344-.148 2.381 2.381 0 0 0-.58-.664 1.715 1.715 0 0 0-1.032-.352zM27.436 15.5c-.517 0-.994.203-1.338.578-.344.383-.54.907-.54 1.477 0 .602.227 1.15.728 1.75.485.587 1.212 1.204 2.049 1.923.258.22.54.461.837.72.078.07.195.07.273 0 .298-.259.587-.5.837-.72.837-.71 1.564-1.328 2.05-1.922.5-.61.727-1.149.727-1.75 0-.571-.196-1.095-.54-1.478a1.792 1.792 0 0 0-1.33-.578c-.375 0-.727.117-1.032.36a2.32 2.32 0 0 0-.57.656.333.333 0 0 1-.196.148.316.316 0 0 1-.344-.148 2.38 2.38 0 0 0-.58-.664 1.715 1.715 0 0 0-1.031-.352z"
          fill="#111"
        />
        <path
          d="m17.48 25.813-.38.282.38-.282a3.25 3.25 0 0 0-4.546-.672l.298.401-.298-.401a3.25 3.25 0 0 0-.672 4.546c1.478 1.992 3.475 3.482 5.654 4.46 2.182.98 4.577 1.464 6.958 1.464 2.38 0 4.775-.484 6.957-1.464 2.179-.978 4.176-2.468 5.655-4.46a3.25 3.25 0 0 0-5.22-3.874c-.732.987-1.796 1.82-3.097 2.404-1.3.584-2.782.894-4.295.894-1.514 0-2.995-.31-4.296-.894-1.3-.584-2.365-1.417-3.097-2.404z"
          fill="#111"
          stroke="#000"
          strokeLinecap="round"
        />
        <mask
          id="a"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="12"
          y="25"
          width="26"
          height="11"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.515 25.542a2.75 2.75 0 0 1 .57 3.847c-1.422 1.915-3.347 3.354-5.458 4.302-2.115.949-4.44 1.42-6.753 1.42-2.314 0-4.64-.471-6.753-1.42-2.111-.948-4.037-2.387-5.458-4.302a2.75 2.75 0 0 1 4.416-3.278c.79 1.064 1.926 1.948 3.295 2.562 1.368.615 2.92.938 4.5.938s3.132-.323 4.5-.938c1.368-.614 2.504-1.498 3.294-2.562a2.75 2.75 0 0 1 3.847-.569z"
            fill="#111"
          />
        </mask>
        <g mask="url(#a)" stroke="#000" strokeLinecap="round">
          <path
            d="m17.909 25.813-.38.282.38-.282a3.25 3.25 0 0 0-4.547-.672l.298.401-.298-.401a3.25 3.25 0 0 0-.673 4.546c1.479 1.992 3.476 3.482 5.654 4.46 2.183.98 4.578 1.464 6.958 1.464 2.381 0 4.776-.484 6.958-1.464 2.179-.978 4.176-2.468 5.654-4.46a3.25 3.25 0 1 0-5.219-3.874c-.732.987-1.797 1.82-3.098 2.404-1.3.584-2.782.894-4.295.894s-2.994-.31-4.295-.894c-1.3-.584-2.365-1.417-3.097-2.404z"
            fill="#111"
          />
          <path
            d="M37.785 27.992c.556-.453.829-1.075.672-1.717-.15-.615-.66-1.103-1.341-1.41-.688-.309-1.497-.413-2.25-.345-.75.067-1.499.309-2.042.752-.703.573-1.746 1.072-3.044 1.425-1.294.352-2.77.54-4.28.54-1.51 0-2.986-.188-4.28-.54-1.298-.353-2.34-.852-3.044-1.425-.543-.443-1.292-.685-2.041-.752-.754-.068-1.563.036-2.25.346l.18.404-.18-.404c-.683.306-1.191.794-1.341 1.409-.158.643.115 1.264.671 1.717 1.465 1.194 3.423 2.073 5.535 2.648 2.12.576 4.442.86 6.75.86s4.63-.284 6.75-.86c2.112-.575 4.07-1.454 5.535-2.648z"
            fill="#fff"
          />
        </g>
        <ellipse
          cx="41.131"
          cy="21.253"
          rx="2.75"
          ry="1.5"
          transform="rotate(-17.342 41.13 21.253)"
          fill="#111"
          fillOpacity=".3"
        />
        <ellipse
          cx="8.632"
          cy="21.252"
          rx="2.75"
          ry="1.5"
          transform="rotate(30 8.632 21.252)"
          fill="#111"
          fillOpacity=".3"
        />
        <circle cx="17.561" cy="17.5" r=".5" fill="#fff" />
        <circle cx="27.561" cy="17.5" r=".5" fill="#fff" />
      </g>
      <g className="positive-2">
        <path
          d="M1 21C1 9.954 9.954 1 21 1h8c11.046 0 20 8.954 20 20v8c0 11.046-8.954 20-20 20h-8C9.954 49 1 40.046 1 29v-8z"
          fill="#4AC9FF"
        />
        <path
          d="M21 1.5h8c10.77 0 19.5 8.73 19.5 19.5v8c0 10.77-8.73 19.5-19.5 19.5h-8C10.23 48.5 1.5 39.77 1.5 29v-8C1.5 10.23 10.23 1.5 21 1.5z"
          stroke="#111"
          strokeOpacity=".8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.867 27.59c1.244.985 1.503 2.858.58 4.185-1.448 2.083-3.411 3.648-5.563 4.68A15.962 15.962 0 0 1 25 38c-2.359 0-4.729-.512-6.884-1.545-2.152-1.032-4.115-2.597-5.563-4.68-.923-1.327-.664-3.2.58-4.185 1.243-.985 2.999-.708 3.922.619.805 1.157 1.963 2.119 3.358 2.787 1.394.669 2.976.78 4.587.78 1.61 0 3.193-.111 4.587-.78 1.395-.668 2.553-1.63 3.359-2.787.922-1.327 2.678-1.604 3.921-.62z"
          fill="#111"
        />
        <ellipse
          cx="37.32"
          cy="24.52"
          rx="2.941"
          ry="1.716"
          transform="rotate(-17.449 37.32 24.52)"
          fill="#111"
          fillOpacity=".3"
        />
        <ellipse
          cx="12.286"
          cy="24.419"
          rx="2.941"
          ry="1.716"
          transform="rotate(15 12.286 24.419)"
          fill="#111"
          fillOpacity=".3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.259 25.144a5.392 5.392 0 1 0-9.431-2.338c1.284.168 2.681.42 4.13.754 1.966.454 3.777 1.004 5.3 1.584z"
          fill="#fff"
        />
        <circle
          cx="19.922"
          cy="20.407"
          r="2.206"
          transform="rotate(13.007 19.922 20.407)"
          fill="#111"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.123 22.909a5.392 5.392 0 1 0-9.981 1.946c1.872-.686 4.476-1.3 7.387-1.68.891-.117 1.76-.205 2.594-.266z"
          fill="#fff"
        />
        <circle
          cx="29.515"
          cy="20.905"
          r="2.206"
          transform="rotate(-7.456 29.515 20.905)"
          fill="#111"
        />
        <path
          d="M28.694 20.447c0-.552.346-1.38 1.036-1.38 0 0 .345 0 .345.69s-1.035 1.035-1.035 1.726c0 .69-1.036 1.035-1.036.345s.69-.828.69-1.38zM19.811 20.722c-.129.56-.672 1.317-1.37 1.156 0 0-.35-.081-.189-.78.162-.699 1.29-.806 1.452-1.505.162-.699 1.29-.806 1.13-.107-.162.699-.893.677-1.023 1.236z"
          fill="#fff"
        />
      </g>
      <g className="positive-3">
        <path
          d="M1 13C1 6.373 6.373 1 13 1h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H13C6.373 49 1 43.627 1 37V13z"
          fill="#97E1FF"
        />
        <path
          d="M13 1.5h24c6.351 0 11.5 5.149 11.5 11.5v24c0 6.351-5.149 11.5-11.5 11.5H13C6.649 48.5 1.5 43.351 1.5 37V13C1.5 6.649 6.649 1.5 13 1.5z"
          stroke="#111"
          strokeOpacity=".8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.229 29.364a1 1 0 0 1 1.407-.135c1.713 1.412 4.79 3.13 8.367 3.63 3.536.492 7.564-.202 11.327-3.601a1 1 0 0 1 1.34 1.484c-4.255 3.845-8.898 4.66-12.943 4.097-4.003-.558-7.417-2.462-9.363-4.068a1 1 0 0 1-.135-1.407z"
          fill="#111"
        />
        <ellipse
          cx="39.234"
          cy="26.188"
          rx="2.941"
          ry="1.716"
          transform="rotate(-17.449 39.234 26.188)"
          fill="#111"
          fillOpacity=".3"
        />
        <ellipse
          cx="9.163"
          cy="26.188"
          rx="2.941"
          ry="1.716"
          transform="rotate(15 9.163 26.188)"
          fill="#111"
          fillOpacity=".3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.007 27.989a4.657 4.657 0 1 0-5.92-2.587c.595.007 1.2.124 1.785.362l2.318.942c.72.293 1.333.738 1.817 1.283z"
          fill="#fff"
        />
        <circle
          cx="20.638"
          cy="23.194"
          r="2.206"
          transform="rotate(-150 20.638 23.194)"
          fill="#111"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.746 24.303a4.657 4.657 0 1 0-6.531 3.475 6.099 6.099 0 0 1 2.304-1.8l2.712-1.218a6.13 6.13 0 0 1 1.515-.457z"
          fill="#fff"
        />
        <circle
          cx="28.905"
          cy="23.118"
          r="2.206"
          transform="rotate(150 28.905 23.118)"
          fill="#111"
        />
      </g>
    </svg>
  );
};
